module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-00.2.ae77938c.jpg";